const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

const IconPhone = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.3 1L6.6 10.8z" />
  </svg>
);

const IconMail = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
  </svg>
);

const IconMap = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z" />
  </svg>
);

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            <div>
              <div className="nav-logo" style={{ cursor: 'default' }}>
                <img
                  src={`${process.env.PUBLIC_URL}/img/ACEROS J13 - copia (1).ico`}
                  alt="Aceros Jalos"
                  className="logo-img"
                />
                <div className="logo-text">
                  <span className="logo-name">Aceros Jalos</span>
                  <span className="logo-sub">Jalostotitlán, Jal.</span>
                </div>
              </div>
              <p className="footer-brand-desc">
                Distribuidora de materiales de acero en Jalostotitlán, Jalisco.
                Calidad y confianza para tus proyectos de construcción e industria.
              </p>
            </div>

            <div>
              <h4 className="footer-heading">Navegación</h4>
              <div className="footer-links">
                <button onClick={() => scrollTo('inicio')}>Inicio</button>
                <button onClick={() => scrollTo('productos')}>Productos</button>
                <button onClick={() => scrollTo('nosotros')}>Nosotros</button>
                <button onClick={() => scrollTo('contacto')}>Contacto</button>
              </div>
            </div>

            <div>
              <h4 className="footer-heading">Productos</h4>
              <div className="footer-links">
                <button onClick={() => scrollTo('productos')}>Viga / IPR</button>
                <button onClick={() => scrollTo('productos')}>Varilla corrugada</button>
                <button onClick={() => scrollTo('productos')}>Tubo y PTR</button>
                <button onClick={() => scrollTo('productos')}>Lámina para techo</button>
                <button onClick={() => scrollTo('productos')}>Angulos y Soleras</button>
              </div>
            </div>

            <div>
              <h4 className="footer-heading">Contacto</h4>
              <div className="footer-contact-item">
                <span className="footer-contact-icon"><IconMap /></span>
                Carretera a San Juan #191, Jalostotitlán, Jalisco
              </div>
              <div className="footer-contact-item">
                <span className="footer-contact-icon"><IconPhone /></span>
                431 746 3865
              </div>
              <div className="footer-contact-item">
                <span className="footer-contact-icon"><IconMail /></span>
                acerosjalos@hotmail.com
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p className="footer-copyright">
            © {year} <span>Aceros Jalos</span>. Todos los derechos reservados.
          </p>
          <p className="footer-slogan">Calidad en cada tonelada</p>
        </div>
      </div>
    </footer>
  );
}
